<!-- eslint-disable vue/no-mutating-props -->
<template>
  <b-form-group :class="classFormGroupBind">
    <b-form-checkbox
      v-model="value"
      @input="($value) => $emit('input', $value)"
      :disabled="disabled"
    >
      <span class="checkbox">
        {{ label || "Ativo" }}
      </span>
    </b-form-checkbox>
  </b-form-group>
</template>
<script>
export default {
  inheritAttrs: false,
  props: {
    cols: String,
    sm: String,
    md: String,
    classFormGroup: {
      type: String,
      default: "",
    },
    label: String,
    value: [String, Number, Boolean],
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classFormGroupBind() {
      const responsiveCols =
        (this.cols !== undefined ? `col-${this.cols} ` : "") +
          (this.sm !== undefined ? `col-sm-${this.sm} ` : "") +
          (this.md !== undefined ? `col-md-${this.md} ` : "") || "col-12 ";
      return `${responsiveCols} ${this.classFormGroup}`;
    },
  },
};
</script>
<style scoped>
.checkbox {
  font-size: 14px;
  margin-left: -30px;
}
</style>
